import React from 'react'
import compose from 'recompose/compose'
import withWidth, { isWidthDown } from '@material-ui/core/withWidth'
import { Grid, Avatar, Typography, withStyles } from '@material-ui/core'
import { MFSDR } from 'Constants/MouseFlow/SensitiveDataReplacer'
import cn from 'classnames'
import themeCreateInjectableStyles from 'Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support'
import AccountPageAccountDetailsStyles from './AccountDetails.styles'
import Alert from 'Components/OrderDetailsHeader/parts/comps/Alert'
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd'
import HeaderWithIcon from '../comps/HeaderWithIcon'
import FieldValuePair from '../comps/FieldValuePair'
import HorizontalLine from 'Components/HorizontalLine/HorizontalLine'

interface Props {
  any?: any,
  width: any,
  classes: any,
  account: any,
}

const AccountPageCustomerDetailsComponent = (props: Props) => {
  const {
    width,
    classes,
    account,
  } = props
  const isSmDown = isWidthDown(`sm`, width)
  return (
    <div className={classes.wrapper}>
      <HeaderWithIcon
        icon={<AssignmentIndIcon />}
        text={`Customer Details`}
      />
      { account.CustomerName &&
        <FieldValuePair
          fieldName={`Customer Name`}
          valueText={account.CustomerName}
        />
      }
      { account.CustomerAccountCode &&
        <FieldValuePair
          fieldName={`Customer Number`}
          valueText={account.CustomerAccountCode}
        />
      }
      { account.CustomerABN &&
        <FieldValuePair
          fieldName={`ABN`}
          valueText={account.CustomerABN}
        />
      }
      <Alert
        content={
          <React.Fragment>
            <Typography variant='body1' className={cn(classes.displayInline, classes.alertContentText)} component='span'>
              { `The Customer is the organisation that holds this Account with Boral. It is sometimes referred to as the` }
            </Typography>
            <Typography variant='body1' className={cn(classes.displayInline, classes.alertContentText, classes.fontWeight500)} component='span'>
              { ` Client ` }
            </Typography>
            <Typography variant='body1' className={cn(classes.displayInline, classes.alertContentText)} component='span'>
              { `or` }
            </Typography>
            <Typography variant='body1' className={cn(classes.displayInline, classes.alertContentText, classes.fontWeight500)} component='span'>
              { ` Company` }
            </Typography>
            <Typography variant='body1' className={cn(classes.displayInline, classes.alertContentText)} component='span'>
              { `.` }
            </Typography>
          </React.Fragment>
        }
      />
      <HorizontalLine />
    </div>
  )
}

const AccountPageCustomerDetails = compose<any, any>(
  withWidth(),
  withStyles(themeCreateInjectableStyles(AccountPageAccountDetailsStyles) as any, { withTheme: true }),
)(AccountPageCustomerDetailsComponent)


export default AccountPageCustomerDetails
